var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccepted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.293,
    height: 88.195,
    viewBox: "0 0 78.293 88.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(-2773.129 -7900.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M2786.884,7958.65V7901h57.925v68.831",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M2794.783,7930.024a43.363,43.363,0,0,0,9.181,1.378c4.017,0,8.034-2.569,8.034-5.738s-5.623-5.165-8.034-5.739-8.034-2.569-8.034-5.738,4.017-5.739,8.034-5.739a63.692,63.692,0,0,1,9.182.917",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_789",
    "data-name": "Line 789",
    x2: 0.113,
    y2: 31.332,
    transform: "translate(2803.964 7904.774)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_790",
    "data-name": "Line 790",
    x2: 21.289,
    transform: "translate(2817.376 7907.057)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_791",
    "data-name": "Line 791",
    x2: 21.289,
    transform: "translate(2817.376 7915.482)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_792",
    "data-name": "Line 792",
    x2: 21.289,
    transform: "translate(2817.376 7923.907)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_793",
    "data-name": "Line 793",
    x2: 21.289,
    transform: "translate(2817.376 7932.332)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_794",
    "data-name": "Line 794",
    x2: 44.869,
    transform: "translate(2793.796 7943.182)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_795",
    "data-name": "Line 795",
    x2: 44.869,
    transform: "translate(2793.796 7951.607)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 15.374,
    height: 27.952,
    transform: "translate(2773.726 7958.65)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M2790.5,7962.843h13.868c4.3,0,11.288,1.4,15.481,4.193s0,11.181-6.988,8.386",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M2805.871,7972.626s12.579,5.591,18.169,5.591,12.293-4.29,15.957-6.289c6.405-3.494,9.713-1.953,10.6.7,1.4,4.193-4.192,8.386-6.988,9.784s-11.18,5.59-19.566,5.59-16.771-5.59-23.759-5.59-9.783,0-9.783,0",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.8653c7e2bae556af41eff92a3e044587.svg";
export { ForwardRef as ReactComponent };